import React, { useState } from 'react';
import { FilterType } from '../FilterData';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  CancleButton,
  Wrapper,
} from '../filterOptionModal/OptionModal.styles';
import { styled } from 'styled-components';
import DatePicker from '../../components/calendar/DatePicker';

interface Props {
  option: 'saleDate' | 'approvalDate';
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function DateOption({ option, onClose, filters, setFilters }: Props) {
  const [openOption, setOpenOption] = useState<null | 'start' | 'end'>(null);
  const [selectStart, setSelectStart] = useState(filters[option]?.start || '');
  const [selectEnd, setSelectEnd] = useState(filters[option]?.end || '');

  const foramtDateWithDot = (value: string) => {
    return `${value.replaceAll('-', '.')}.`;
  };

  const handleReset = () => {
    onClose();
  };
  const handleSubmit = () => {
    setFilters({
      ...filters,
      [option]: {
        start: selectStart,
        end: selectEnd,
      },
      // type: selectType,
    });
    onClose();
  };
  return (
    <Wrapper>
      <Inner>
        <OptionBox>
          {option === 'saleDate' ? '매각기일' : '사용승인'}
          <InputBox>
            <DateInput
              isNull={selectStart === ''}
              active={openOption === 'start'}
              onClick={() => setOpenOption('start')}
            >
              {selectStart === ''
                ? '연도. 월. 일.'
                : foramtDateWithDot(selectStart)}
            </DateInput>
            <Text>~</Text>
            <DateInput
              isNull={selectEnd === ''}
              active={openOption === 'end'}
              onClick={() => setOpenOption('end')}
            >
              {selectEnd === ''
                ? '연도. 월. 일.'
                : foramtDateWithDot(selectEnd)}
            </DateInput>
          </InputBox>
        </OptionBox>
        {openOption === 'start' && (
          <DatePicker selected={selectStart} setSelected={setSelectStart} />
        )}
        {openOption === 'end' && (
          <DatePicker selected={selectEnd} setSelected={setSelectEnd} />
        )}
      </Inner>
      <Bottom>
        <ButtonBox>
          <CancleButton onClick={handleReset}>취소</CancleButton>
          <ApplyButton onClick={handleSubmit}>저장</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default DateOption;

const Inner = styled.div`
  flex: 1;
`;

const OptionBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 12px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const InputBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
`;

const DateInput = styled.div<{ isNull?: boolean; active?: boolean }>`
  width: 100%;
  border-radius: 8px;
  padding: 10px 12px;
  background-color: #f7f8fc;
  border: ${({ active }) => active && `1px solid  #008AFF`};

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ isNull }) => (isNull ? '#616161' : '#222222')};
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;
